import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import Img from '../share/Img';
import useCart from '@/app/_hooks/useCart';
import Price from '../share/Price';

export default function ProductOffer({ product }) {
  const { cart, addToCart } = useCart();
  const [isProductInCart, setIsProductInCart] = useState(false);

  useEffect(() => {
    if (cart && cart.length > 0 && product.prices.length > 0) {
      setIsProductInCart(
        cart.some((item) => item.price_id === product.prices[0].id)
      );
    }
  }, [cart]);

  const addToCartHandler = async () => {
    let newItem = {
      number: 1,
      price_id: product.prices[0].id,
      variation: {
        product: {
          media: {
            thumb: product.media?.thumb,
          },
          slug: product.slug,
          title: product.title,
        },
        regular: product.prices[0].regular,
        sale: product.prices[0].sale,
      },
    };
    addToCart({ items: [newItem] });
  };
  return (
    <div>
      <div className="os-product-wrap text-center pb-2 md:py-7 md:px-7">
        <Link href={`/product/${product.slug}`}>
          <div className="md:flex ">
            <div>
              <div className="os-product-img max-w-[140px] mx-auto">
                <Img image={product.media.thumb} width={140} height={140} />
              </div>
            </div>
            <div className=" md:pr-5">
              <div>
                <div className="mb-2 pt-2">{product.title}</div>
              </div>

              {product.brand.length > 0 && (
                <div className="flex items-center mt-2 md:mt-10 justify-center md:justify-start">
                  <span className="pl-2 "> برند: </span>
                  <div className="relative max-w-50px w-[50px] h-[50px] flex items-center">
                    <Image
                      src={product?.brand[0]?.thumb?.full_path}
                      alt="barghchi"
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                      width={50}
                      height={50}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </Link>

        <div className="priceAddToCart md:mt-4  flex-row-reverse md:flex justify-between items-center">
          <div className="flex justify-center mb-2 md:mb-0">
            <Price price={product.prices[0]} large="true" />
          </div>

          {product.prices.length > 0 &&
          product.type === 'simple' &&
          product.prices[0].stock > 0 &&
          !product.offline ? (
            <div className="cursor-pointer text-sm ">
              {isProductInCart ? (
                <Link
                  href="/checkout/cart"
                  className={` bg-color-primary  hover:shadow-primary transition text-white py-2 rounded-md  SpAddTocartButton px-10 `}
                >
                  مشاهده سبد خرید
                </Link>
              ) : (
                <button
                  className={`bg-color-primary  hover:shadow-primary transition text-white py-2 rounded-md  SpAddTocartButton px-10 `}
                  onClick={addToCartHandler}
                  disabled={product.prices[0].stock == 0 ? true : false}
                >
                  افزودن به سبد خرید
                </button>
              )}
            </div>
          ) : (
            <Link
              href={`/product/${product.slug}`}
              className={` bg-color-primary text-white py-2 rounded-md text-base SpAddTocartButton px-10 `}
            >
              مشاهده محصول
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
